<template>
    <div class="nav-mobile">
        <div class="main-nav navbar slideout-menu slideout-menu-left open" id="nav-mobile" v-if="IsOpenLeftMenu">
            <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav">
                <li id="menu-item-17633" class="nav-item menu-item menu-item-type-post_type menu-item-object-page " v-for="link in NavLinks">
                    <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}" @click="CloseLeftMenu">{{link.displayText}}</router-link>
                </li>
            </ul>
        </div>
        <div class="main-nav navbar slideout-menu slideout-menu-right open" id="nav-mobile1" v-if="IsOpenRightMenu">

            <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav" v-if="!isUserLoggedIn">

                <li class="nav-item menu-item menu-item-type-post_type menu-item-object-page ">
                    <router-link class="nav-link" :to="{name:'Login'}" @click="OpenRightMenu">
                        <i class="houzez-icon icon-lock-5 me-1"></i>{{$t('StoreFront.Login')}}
                    </router-link>
                </li>
                <li class="nav-item menu-item menu-item-type-post_type menu-item-object-page ">
                    <router-link class="nav-link" :to="{name:'SignupPage'}" @click="OpenRightMenu">
                        <i class="houzez-icon icon-single-neutral-circle me-1"></i>{{$t('DefaultTheme.SignUp')}}
                    </router-link>
                </li>
            </ul>
            <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav" v-if="isUserLoggedIn">
                <li class="nav-item menu-item menu-item-type-post_type menu-item-object-page">
                    <a class="nav-link rm-usrnme" href="javascript:;" v-if="$filters.IsNull(name,true,null)!=null"> {{name.firstName}} {{name.lastName}}</a>
                </li>
                <li class="nav-item menu-item menu-item-type-post_type menu-item-object-page">
                    <a class="nav-link" href="javascript:;" @click="goToPortalDashboard">{{$t('StoreFront.GoToPortal')}} </a>
                </li>
                <li class="nav-item menu-item menu-item-type-post_type menu-item-object-page">
                    <a class="nav-link" routerlinkactive="active" @click="logoutfrommenu" ng-reflect-router-link-active="active">{{$t('StoreFront.Logout')}}</a>
                </li>
            </ul>

        </div>
    </div>

    <nav class="navbar navbar-default dark-bg navbar-expand-lg " id="headersticky">
        <div class="container">
            <div class="header-inner-wrap">
                <div class="navbar d-flex align-items-center">
                    <div class="logo logo-desktop">
                        <router-link :to="{ name: 'HomePage'}">
                            <img :src="companyLogo" :alt="companyname" style="max-height: 40px; max-width:250px; ">
                        </router-link>
                    </div>

                    <nav class="main-nav on-hover-menu navbar-expand-lg flex-grow-1">
                        <ul id="main-nav" class="navbar-nav nav-left">


                            <li id="menu-item-17633" class="nav-item menu-item menu-item-type-post_type menu-item-object-page dropdown" v-for="(link, index)  in NavLinks" :key="index">


                                <router-link :class="[JSON.parse(link.childMenu).length >0 ? 'dropdown-toggle' : '','nav-link']" :to="{ name: link.routeUrl,params:link.params}">
                                    {{link.displayText}}
                                </router-link>
                                <ul class="dropdown-menu" v-if="JSON.parse(link.childMenu).length > 0">
                                    <li v-for="childLink in JSON.parse(link.childMenu)">
                                        <router-link class="nav-link" :to="{path:childLink.routeUrl}">{{childLink.displayText}}</router-link>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </nav>
                    <!-- main-nav -->
                    <div class="login-register on-hover-menu" v-if="!isUserLoggedIn">
                        <ul class="login-register-nav dropdown d-flex align-items-center">

                            <li class="login-link">
                                <router-link :to="{name:'Login'}">{{$t('StoreFront.Login')}}</router-link>
                            </li>
                            <li class="register-link">
                                <router-link :to="{name:'SignupPage'}">{{$t('DefaultTheme.SignUp')}}</router-link>
                            </li>

                        </ul>
                    </div>


                    <div class="login-register on-hover-menu" v-if="isUserLoggedIn">
                        <ul class="login-register-nav dropdown d-flex align-items-center">
                            <li class="nav-item dropdown pr-link show">
                                <a class="nav-link dropdown-toggle useraccount" data-toggle="dropdown" href="#/dashboard" aria-expanded="true">
                                    <!--<i class="houzez-icon icon-single-neutral-circle ms-1 me-2"></i>-->
                                    <img :src="ProfilePic" alt="img">
                                    <span class="rm-usrnme">{{name.firstName}} {{name.lastName}}</span>
                                </a>

                                <ul class="dropdown-menu show">
                                    <li>

                                        <a class="login-link" href="javascript:;" @click="$emit('goToPortal')">{{$t('StoreFront.GoToPortal')}}</a>

                                    </li>
                                    <li>
                                        <a class="login-link" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active">{{$t('StoreFront.Logout')}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>

                    <div id="changeLanguage" class="login-register on-hover-menu">
                      
                        <ul class="login-register-nav dropdown d-flex align-items-center">
                            <li class="nav-item dropdown pr-link show">
                                <span class="dropdown-toggle">{{currentSelectLang}}</span>
                                <ul class="dropdown-menu show">
                                    <li><a href="#" v-for=" lang in LanguageList" @click="ChangeLanguage(lang)">{{lang.text}} </a></li>
                                </ul>
                            </li>


                        </ul>
                    </div>
                </div>

               
                <!-- navbar -->

                <div id="header-mobile" class="header-mobile d-flex align-items-center" data-sticky="">
                    <div class="header-mobile-left">
                        <button class="btn toggle-button-left" @click="ToggleLeftMenu">
                            <i class="houzez-icon icon-navigation-menu"></i>
                        </button>
                    </div>
                    <div class="header-mobile-center flex-grow-1">
                        <div class="logo logo-mobile">
                            <router-link :to="{ name: 'HomePage'}">
                                <img :src="companyLogo" height="20" width="180" :alt="companyname">
                            </router-link>
                        </div>
                    </div>
                    <div class="header-mobile-right">
                        <button class="btn toggle-button-right" @click="OpenRightMenu">
                            <img v-if="isUserLoggedIn" :src="ProfilePic" alt="img">
                            <i v-else class="houzez-icon icon-single-neutral-circle ml-1"></i>
                        </button>
                    </div>
                </div>

            </div>
        </div>
    </nav>

</template>
<script>
    import side from '@/views/AuthorizedUserView/AuthorizeUserLayout/SideMenu.vue'
    import service from '@/Services/frontEndService.js'
    export default {
        name: 'HeaderVue',
        components: {
            side
        },

        emits: ["openSignUpdmodel", "openLoginModel", "logout"],
        data() {
            return {
                companyLogo: '',
                IsOpenLeftMenu: false,
                IsOpenRightMenu: false,
                companyname: localStorage.getItem('companyName'),
                LanguageList: [],
                LanguageId: null,
                currentSelectLang: ''
            }
        },
        props: ['NavLinks', 'isUserLoggedIn', 'sideMenuItems', 'name', 'ProfilePic'],
        created() {
            this.getCompanyLogo();
            this.GetlanguageList();
            if (localStorage.getItem('Language') == 'en') {
                this.LanguageId = '364697eb-c5d6-44fa-8c08-ece45aed1844';
                 this.currentSelectLang = "English"
                 document.body.className="English"
            } else {
                this.LanguageId = 'cdf82d9b-07af-427e-9261-a3f45bc98f8f';
              this.currentSelectLang = "Spanish"
              document.body.className="Spanish"
            }
        },
        methods: {
            GetlanguageList() {
                if (this.userId == null || this.userId == undefined) {
                    this.userId = '00000000-0000-0000-0000-000000000000'
                }
                service.GetLanguageList('Language', 'Language', this.userId)
                    .then(response => {
                        this.LanguageList = response.data;
                    });
            },
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companySecondaryLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
            },
            OpenRightMenu() {
                this.IsOpenRightMenu = (this.IsOpenRightMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let sectioncomparison = document.getElementsByClassName("comparisonblock");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenRightMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < sectioncomparison.length; i++) {
                        sectioncomparison[i].classList.add("show-menu1");
                    }
                    // footerbottom.classList.add("show-menu1");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < sectioncomparison.length; i++) {
                        sectioncomparison[i].classList.remove("show-menu1");
                    }
                    //  footerbottom.classList.remove("show-menu1");
                }

            }, ToggleLeftMenu(Action = null) {
                this.IsOpenLeftMenu = (this.IsOpenLeftMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenLeftMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu");
                    }
                    //footerbottom.classList.add("show-menu");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    //footerbottom.classList.remove("show-menu");
                }
            },
            CloseLeftMenu() {
                if (this.IsOpenLeftMenu) {
                    let navbar = document.getElementsByClassName("navbar-default");
                    let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                    let sectionFooter = document.getElementsByClassName("section-footer");

                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    this.IsOpenLeftMenu = false

                }
            },
            goToPortalDashboard() {
                this.OpenRightMenu();
                this.$emit('goToPortal')
            },
            logoutfrommenu() {
                this.OpenRightMenu();
                this.$emit('logout');
            },
            //ChangeLanguage(event) {
            //    this.currentSelectLang = event.text;
            //    var item = this.LanguageList.find(x => x.value == event.value);
            //    localStorage.removeItem("Language");
            //    localStorage.removeItem("LanguageId");
            //    localStorage.setItem("Language", item.masterName);
            //    localStorage.setItem("languageId", item.value);
            //    this.$router.go(0);
            //},
            ChangeLanguage(event) {
                var item = this.LanguageList.find(x => x.value == event.value);
                let model = {
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId"),
                    SelectedLanguage: this.LanguageId
                }
                localStorage.removeItem("domain");
                localStorage.removeItem("Language");
                localStorage.removeItem("LanguageId");
                localStorage.setItem("Language", item.masterName);
                localStorage.setItem("languageId", item.value);
                this.$router.go(0);
            },
        }
    }
</script>
